var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("loading", {
        attrs: {
          active: _vm.isLoading,
          "enforce-focus": false,
          loader: "dots",
        },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c(
        "div",
        { staticClass: "page-tabs" },
        [
          _vm._l(_vm.rows, function (item, index) {
            return [
              _c(
                "a",
                {
                  key: item.index,
                  class: { active: _vm.currentTab === index },
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      _vm.currentTab = index
                    },
                  },
                },
                [_vm._v(" " + _vm._s(item.title) + " ")]
              ),
            ]
          }),
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "page-tabs-content" },
        [
          _c("ValidationObserver", {
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ handleSubmit }) {
                  return _vm._l(_vm.rows, function (item, index) {
                    return _c("div", { key: item.index }, [
                      _vm.currentTab === index
                        ? _c("table", { staticClass: "table" }, [
                            _c(
                              "tbody",
                              [
                                _vm._l(item.content, function (data) {
                                  return _c("tr", { key: data.index }, [
                                    _c("th", { attrs: { id: "mail" } }, [
                                      _vm._v(" " + _vm._s(data.Item) + " "),
                                      data.Item === "Gmail信件收集履歷"
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "explanation",
                                              attrs: {
                                                "data-toggle": "modal",
                                                "data-target":
                                                  "#gmailExplanationModal",
                                              },
                                            },
                                            [_vm._v(" ? ")]
                                          )
                                        : _vm._e(),
                                      data.Item === "O365信件收集履歷"
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "explanation",
                                              attrs: {
                                                "data-toggle": "modal",
                                                "data-target":
                                                  "#officeExplanationModal",
                                              },
                                            },
                                            [_vm._v(" ? ")]
                                          )
                                        : _vm._e(),
                                    ]),
                                    data.DataType === "String"
                                      ? _c("td", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model.trim",
                                                value: data.Value,
                                                expression: "data.Value",
                                                modifiers: { trim: true },
                                              },
                                            ],
                                            staticClass: "form-control",
                                            attrs: { type: "text" },
                                            domProps: { value: data.Value },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  data,
                                                  "Value",
                                                  $event.target.value.trim()
                                                )
                                              },
                                              blur: function ($event) {
                                                return _vm.$forceUpdate()
                                              },
                                            },
                                          }),
                                        ])
                                      : _vm._e(),
                                    data.DataType === "Password"
                                      ? _c("td", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model.trim",
                                                value: data.Value,
                                                expression: "data.Value",
                                                modifiers: { trim: true },
                                              },
                                            ],
                                            staticClass: "form-control",
                                            attrs: { type: "password" },
                                            domProps: { value: data.Value },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  data,
                                                  "Value",
                                                  $event.target.value.trim()
                                                )
                                              },
                                              blur: function ($event) {
                                                return _vm.$forceUpdate()
                                              },
                                            },
                                          }),
                                        ])
                                      : _vm._e(),
                                    data.DataType === "Int"
                                      ? _c(
                                          "td",
                                          [
                                            _c("el-input-number", {
                                              staticClass: "w-100",
                                              attrs: { min: 1, max: 99999 },
                                              on: {
                                                blur: function ($event) {
                                                  !data.Value
                                                    ? (data.Value = 1)
                                                    : null
                                                },
                                              },
                                              model: {
                                                value: data.Value,
                                                callback: function ($$v) {
                                                  _vm.$set(data, "Value", $$v)
                                                },
                                                expression: "data.Value",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    data.DataType === "Bool"
                                      ? _c(
                                          "td",
                                          [
                                            _c(
                                              "el-radio",
                                              {
                                                attrs: { label: "true" },
                                                model: {
                                                  value: data.Value,
                                                  callback: function ($$v) {
                                                    _vm.$set(data, "Value", $$v)
                                                  },
                                                  expression: "data.Value",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.i18n("Basic.On")
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "el-radio",
                                              {
                                                attrs: { label: "false" },
                                                model: {
                                                  value: data.Value,
                                                  callback: function ($$v) {
                                                    _vm.$set(data, "Value", $$v)
                                                  },
                                                  expression: "data.Value",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.i18n("Basic.Off")
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    data.DataType === "Img"
                                      ? _c(
                                          "td",
                                          [
                                            _c(
                                              "el-upload",
                                              {
                                                staticClass: "upload-demo",
                                                attrs: {
                                                  action: "",
                                                  accept:
                                                    "image/jpeg,image/png",
                                                  "auto-upload": false,
                                                  "show-file-list": false,
                                                  "list-type": "picture",
                                                  "on-change": _vm.uploadFile,
                                                },
                                                model: {
                                                  value: data.Value,
                                                  callback: function ($$v) {
                                                    _vm.$set(data, "Value", $$v)
                                                  },
                                                  expression: "data.Value",
                                                },
                                              },
                                              [
                                                data.Guid ===
                                                "606190f5-7c43-ec11-876a-00155d014913"
                                                  ? _c(
                                                      "el-button",
                                                      {
                                                        attrs: {
                                                          size: "small",
                                                          type: "primary",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.clickUpload(
                                                              "homepage"
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v(" 上傳圖片 ")]
                                                    )
                                                  : _vm._e(),
                                                data.Guid ===
                                                "b27958b4-744b-4655-950e-1d819bf24a2a"
                                                  ? _c(
                                                      "el-button",
                                                      {
                                                        attrs: {
                                                          size: "small",
                                                          type: "primary",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.clickUpload(
                                                              "dark"
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v(" 上傳圖片 ")]
                                                    )
                                                  : _vm._e(),
                                                data.Guid ===
                                                "b27958b4-744b-4655-950e-1d819bf24a2b"
                                                  ? _c(
                                                      "el-button",
                                                      {
                                                        attrs: {
                                                          size: "small",
                                                          type: "primary",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.clickUpload(
                                                              "light"
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v(" 上傳圖片 ")]
                                                    )
                                                  : _vm._e(),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "el-upload__tip mark",
                                                    attrs: { slot: "tip" },
                                                    slot: "tip",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " 僅能上傳 jpg/png 檔案，且大小不超過10MB "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c("img", {
                                              staticStyle: {
                                                width: "120px",
                                                height: "120px",
                                              },
                                              attrs: {
                                                src: data.ImgBase64,
                                                alt: "",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ])
                                }),
                                _c("tr", [
                                  _c(
                                    "td",
                                    {
                                      staticClass: "text-center",
                                      attrs: { colspan: "2" },
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-primary",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              handleSubmit(_vm.editConfig(item))
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.i18n("Buttons.Save")) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                              ],
                              2
                            ),
                          ])
                        : _vm._e(),
                    ])
                  })
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._m(0),
      _vm._m(1),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: {
          id: "gmailExplanationModal",
          tabindex: "-1",
          "aria-labelledby": "exampleModalLabel",
          "aria-hidden": "true",
        },
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog modal-dialog-scrollable modal-lg" },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _vm._v("Gmail串接說明"),
              ]),
              _c("div", { staticClass: "modal-body" }, [
                _c("img", {
                  staticStyle: { width: "100%" },
                  attrs: {
                    src: require("@/assets/img/explan/gmail/m_explan_01.jpg"),
                    alt: "",
                  },
                }),
                _c("br"),
                _c("br"),
                _c("img", {
                  staticStyle: { width: "100%" },
                  attrs: {
                    src: require("@/assets/img/explan/gmail/m_explan_02.jpg"),
                    alt: "",
                  },
                }),
                _c("br"),
                _c("br"),
                _c("img", {
                  staticStyle: { width: "100%" },
                  attrs: {
                    src: require("@/assets/img/explan/gmail/m_explan_03.jpg"),
                    alt: "",
                  },
                }),
              ]),
            ]),
          ]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: {
          id: "officeExplanationModal",
          tabindex: "-1",
          "aria-labelledby": "exampleModalLabel",
          "aria-hidden": "true",
        },
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog modal-dialog-scrollable modal-lg" },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _vm._v("Microsoft Graph API"),
              ]),
              _c("div", { staticClass: "modal-body" }, [
                _c("img", {
                  staticStyle: { width: "100%" },
                  attrs: {
                    src: require("@/assets/img/explan/office/Microsoft Graph API (Email)-1.jpg"),
                    alt: "",
                  },
                }),
                _c("br"),
                _c("br"),
                _c("img", {
                  staticStyle: { width: "100%" },
                  attrs: {
                    src: require("@/assets/img/explan/office/Microsoft Graph API (Email)-2.jpg"),
                    alt: "",
                  },
                }),
                _c("br"),
                _c("br"),
                _c("img", {
                  staticStyle: { width: "100%" },
                  attrs: {
                    src: require("@/assets/img/explan/office/Microsoft Graph API (Email)-3.jpg"),
                    alt: "",
                  },
                }),
                _c("br"),
                _c("br"),
                _c("img", {
                  staticStyle: { width: "100%" },
                  attrs: {
                    src: require("@/assets/img/explan/office/Microsoft Graph API (Email)-4.jpg"),
                    alt: "",
                  },
                }),
                _c("br"),
                _c("br"),
                _c("img", {
                  staticStyle: { width: "100%" },
                  attrs: {
                    src: require("@/assets/img/explan/office/Microsoft Graph API (Email)-5.jpg"),
                    alt: "",
                  },
                }),
                _c("br"),
                _c("br"),
                _c("img", {
                  staticStyle: { width: "100%" },
                  attrs: {
                    src: require("@/assets/img/explan/office/Microsoft Graph API (Email)-6.jpg"),
                    alt: "",
                  },
                }),
              ]),
            ]),
          ]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }